import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../../../styles';
import { ColumnBlock, ColumnContent } from '../../layout/components';
import {
  ContentLinkList,
  PreloadImage,
  PreloadVideo,
} from '../../pages/components';

const LeadContainer = styled.section`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  //margin-bottom: 9rem;
  margin-bottom: 3rem;

  h2 {
    color: ${styles.color.CHARCOAL};
    font-size: 4.25rem !important;
    ${styles.media.phone` font-size: 2.833333333333333rem;`};
  }

  h3 {
    color: ${styles.color.ORANGE};
    font-family: 'ApercuMono';
    font-size: 1rem;
    text-transform: uppercase;
    flex-shrink: 0;
    margin: auto 0 1rem;
  }
`;

const ContentBlock = styled(ColumnBlock).attrs({
  columns: props =>
    props.breakpoint === 'desktop' ? 2 : props.breakpoint === 'tablet' ? 3 : 4,
})``;

const StyledContent = styled(ColumnContent).attrs({
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '5.75rem'),
  paddingLeft: '3.75rem',
  paddingBottom: props => (props.breakpoint === 'phone' ? 0 : '3rem'),
  paddingRight: props =>
    props.breakpoint === 'desktop' ? '18.75rem' : '11.25rem',
})``;

const FigureBlock = styled(ColumnBlock)`
  display: block;
`;

const FigureContainerCircular = styled.div`
  width: 93.5483870967742%;
  padding-top: 93.5483870967742%;
  position: relative;
`;

const FigureCircular = styled.figure`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 0.375rem solid white;
  border-radius: 100%;
  overflow: hidden;
  left: -3rem;
  top: -50%;
  transform: translate3d(0, 0, 0);

  img,
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
`;

const FigureContainerPortrait = styled.div`
  width: 87.0967741935484%;
  padding-top: 145.8064516129032%;
  position: relative;
`;

const FigurePortrait = styled.figure`
  position: absolute;
  left: -5.675rem;
  top: -10rem;
  width: 100%;
  height: 100%;
  transform: translate3d(0, 0, 0);

  img,
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
`;

const PageLead = props => {
  const {
    title,
    subtitle,
    children,
    content,
    breakpoint,
    supportImage,
    supportVideo,
    supportMediaType,
    supportIsCircular,
    links,
  } = props;
  return (
    <LeadContainer>
      {breakpoint !== 'tablet' && (
        <ColumnBlock>
          <ColumnContent paddingTop="3.125rem">
            <h3>{subtitle}</h3>
            <h2>{title}</h2>
          </ColumnContent>
        </ColumnBlock>
      )}
      <ContentBlock breakpoint={breakpoint}>
        <StyledContent breakpoint={breakpoint}>
          {breakpoint === 'tablet' && (
            <React.Fragment>
              <h3>{subtitle}</h3>
              <h2>{title}</h2>
            </React.Fragment>
          )}
          {content ? (
            <React.Fragment>
              <div dangerouslySetInnerHTML={{ __html: content }} />
              {links && <ContentLinkList links={links} />}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {children}
              {links && <ContentLinkList links={links} />}
            </React.Fragment>
          )}
        </StyledContent>
      </ContentBlock>
      {breakpoint !== 'phone' && (
        <FigureBlock>
          {!supportIsCircular ? (
            <FigureContainerPortrait>
              <FigurePortrait>
                <Fragment>
                  {supportVideo && supportMediaType === 'video' ? (
                    <PreloadVideo src={supportVideo} />
                  ) : (
                    <PreloadImage src={supportImage} background />
                  )}
                </Fragment>
              </FigurePortrait>
            </FigureContainerPortrait>
          ) : (
            <FigureContainerCircular>
              <FigureCircular>
                {supportVideo && supportMediaType === 'video' ? (
                  <PreloadVideo src={supportVideo} circular />
                ) : (
                  <PreloadImage src={supportImage} background circular />
                )}
              </FigureCircular>
            </FigureContainerCircular>
          )}
        </FigureBlock>
      )}
    </LeadContainer>
  );
};

PageLead.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
  content: PropTypes.string,
  links: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  supportImage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  supportVideo: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  supportMediaType: PropTypes.string,
  supportIsCircular: PropTypes.bool.isRequired,
};

PageLead.defaultProps = {
  supportIsCircular: false,
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(PageLead);



// WEBPACK FOOTER //
// ./src/modules/content/components/PageLead.js